<template>
  <div class="page-container">
    <el-card class="page-content" shadow="never">
      <el-breadcrumb separator="/" class="page-breadcrumb">
        <el-breadcrumb-item>
          <div class="breadcrumb">
            <div class="left"></div>
            <div class="right"><h2>好友列表</h2></div>
          </div>
        </el-breadcrumb-item>
      </el-breadcrumb>
      <div class="page-actions">
        <div class="select">
          <!-- <div class="item">
            <div class="txt">合伙人UID</div>
            <div class="ipt">
              <el-input placeholder="合伙人UID" clearable v-model="userId">
              </el-input>
            </div>
            
          </div> -->
          <div class="item">
            <div class="ipt">
              <!-- <div class="pre pid"> 合伙人UID:</div>  -->
              <el-input
                placeholder="请输入合伙人UID"
                size="mini"
                clearable
                v-model="channelUserId"
              >
              </el-input>
            </div>
          </div>
          <div class="item">
            <div class="ipt">
              <!-- <div class="pre id"> 下级UID:</div>  -->
              <el-input
                placeholder="请输入下级UID"
                size="mini"
                clearable
                v-model="userId"
              >
              </el-input>
            </div>
          </div>
          <div class="item">
            <div class="ipt">
              <!-- <div class="pre email"> 合伙人手机号或邮箱:</div>  -->
              <el-input
                placeholder="请输入合伙人手机号或邮箱"
                clearable
                size="mini"
                v-model="channelAccount"
              >
              </el-input>
            </div>
          </div>
          <div class="item">
            <div class="ipt">
              <!-- <div class="pre email"> 下级手机号或邮箱:</div>  -->
              <el-input
                placeholder="请输入下级手机号或邮箱"
                clearable
                size="mini"
                v-model="userAccount"
              >
              </el-input>
            </div>
          </div>

          <div class="item">
            <div class="item-sle">
              <div class="tit">特殊账号</div>
              <el-select size="mini" v-model="type" placeholder="特殊账号">
                <el-option
                  v-for="item in [
                    { id: 1, value: '隐藏' },
                    { id: 2, value: '显示' },
                  ]"
                  :key="item.id"
                  :label="item.value"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
          </div>

          <div class="item">
            <el-button size="mini" type="primary" @click="handleSearch"
              >查询</el-button
            >
          </div>
        </div>
      </div>
      <user-list @refresh="refreshList"></user-list>
    </el-card>
    <!-- 添加用户信息弹框 -->
  </div>
</template>

<script>
import "./store";
import UserList from "./components/list";
import { mapState, mapActions, mapMutations } from "vuex";
import { QUERY_TYPE, PAGINATION } from "./constants";
import moment from "moment";
export default {
  name: "friend",
  components: {
    UserList,
  },
  data() {
    return {
      value2: "",
      dialogVisible: false,
      userId: "",
      channelAccount: "",
      channelUserId: "",
      userAccount: "",
      type: 1,
      value1: [
        moment(new Date().getTime() - 7 * 1000 * 24 * 60 * 60).format(
          "YYYY-MM-DD"
        ),
        new Date().getFullYear() +
          "-" +
          (new Date().getMonth() + 1) +
          "-" +
          new Date().getDate(),
      ],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
    };
  },
  computed: {
    ...mapState("friend", ["queryType", "pagination"]),
    ...mapState(["userInfo"]),
  },
  methods: {
    ...mapActions("friend", ["list", "addUser"]),
    ...mapMutations("friend", ["setQueryType"]),
    refreshList(data = {}) {
      this.list({
        userId: this.userId,
        channelUserId: this.channelUserId,
        channelAccount: this.channelAccount,
        userAccount: this.userAccount,
        type: this.type,
        ...this.pagination,
        ...data,
      });
    },

    searchYesterday() {
      this.value1 = [
        moment(new Date().getTime() - 1 * 1000 * 24 * 60 * 60).format(
          "YYYY-MM-DD"
        ),
        moment(new Date().getTime() - 1 * 1000 * 24 * 60 * 60).format(
          "YYYY-MM-DD"
        ),
      ];
      this.handleSearch();
    },
    searchToday() {
      this.value1 = [
        new Date().getFullYear() +
          "-" +
          (new Date().getMonth() + 1) +
          "-" +
          new Date().getDate(),
        new Date().getFullYear() +
          "-" +
          (new Date().getMonth() + 1) +
          "-" +
          new Date().getDate(),
      ];
      this.handleSearch();
    },
    handleSearch() {
      this.list({
        userId: this.userId,
        channelUserId: this.channelUserId,
        channelAccount: this.channelAccount,
        userAccount: this.userAccount,
        type: this.type,
        ...PAGINATION,
      });
    },
    handleSave() {},
    closeDialog() {
      this.dialogVisible = false;
    },
    onOpen() {},
    onClose() {
      this.$refs["elForm"].resetFields();
      this.dialogVisible = false;
    },
    close() {
      // this.$emit("update:visible", false);
      this.$refs["elForm"].resetFields();
      this.dialogVisible = false;
    },
  },
  mounted() {
    console.log("this.$route.query", this.$route.query);
    if (this.$route.query.channelUserId) {
      this.channelUserId = this.$route.query.channelUserId;
      this.handleSearch();
    } else {
      this.handleSearch();
    }
  },
  // created() {
  //   this.list({

  //     userId: this.userId,
  //     channelUserId: this.channelUserId,
  //     channelAccount: this.channelAccount,
  //     userAccount: this.userAccount,
  //     ...PAGINATION,
  //   });
  // },
};
</script>

<style lang="less" src="../../styles/button.less" scoped></style>
